import React from "react";
import "./styles.scss";
import "./mobile.scss";

const Index = () => {
  const adUrl = process.env.REACT_APP_HOME_SIDE_TOP_ADV;
  return (
    <div className="right-ad active">
      <iframe
        title="Advertisement"
        src={adUrl}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        loading="lazy"
      />
    </div>
  );
};

export default Index;
